import { Component, computed, input, Signal } from '@angular/core';
import { DependencyTrackVulnerability } from 'component/details/requirement-intake/requirements-detail/findings/list/findings-list.utils';

interface VulnerabilityId {
  source: string;
  name: string;
  url?: string;
}
export const UNKNOWN = 'UNKNOWN';

@Component({
  selector: 'comp-vulnerability-id-list',
  templateUrl: './vulnerability-id-list.component.html',
  styleUrl: './vulnerability-id-list.component.scss',
})
export class VulnerabilityIdListComponent {
  vulnerability = input.required<DependencyTrackVulnerability>();

  protected readonly vulnerabilityIds: Signal<VulnerabilityId[]> = computed(() => {
    try {
      const vuln = this.vulnerability();
      return [
        toVulnerabilityId(vuln.source, vuln.vulnId),
        ...toVulnerabilityIds(vuln.aliases ?? []),
      ];
    } catch {
      return [{ source: UNKNOWN, name: UNKNOWN }];
    }
  });
}

function toVulnerabilityIds(aliases: Record<string, string>[]): VulnerabilityId[] {
  return aliases.flatMap((alias) =>
    Object.entries(alias).map(([source, name]) => toVulnerabilityId(source, name)),
  );
}

function toVulnerabilityId(source: string | undefined, name: string | undefined): VulnerabilityId {
  const unifiedSource = unifySource(source);
  const vName = name ?? UNKNOWN;
  const url = getVulnerabilityUrl(unifiedSource, name);
  return { source: unifiedSource, name: vName, url: url };
}

function unifySource(source: string | undefined): string {
  switch (source) {
    case undefined:
      return UNKNOWN;
    case 'ghsaId':
      return 'GITHUB';
    case 'cveId':
      return 'NVD';
    case 'osvId':
      return 'OSV';
    default:
      return source;
  }
}

function getVulnerabilityUrl(source: string, name: string | undefined): string | undefined {
  if (!name) {
    return undefined;
  }
  switch (source) {
    case 'GITHUB':
      return `https://github.com/advisories/${name}`;
    case 'NVD':
      return `https://nvd.nist.gov/vuln/detail/${name}`;
    case 'OSV':
      return `https://osv.dev/vulnerability/${name}`;
    default:
      return undefined;
  }
}
